import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../../__utils/spacingClassNamePropType';

const Level = ({ children, level, type, className, qaId }) => {
  const levelClasses = classNames({
    [`uni-bg--level${level}`]: level && type !== 'accent',
    [`uni-bg--level${level}--${type}`]: level && type === 'accent',
    [className]: className,
  });

  return (
    <div className={levelClasses} data-qa-id={qaId}>
      {children}
    </div>
  );
};

Level.propTypes = {
  level: PropTypes.oneOf(['0', '1', '2', '3']).isRequired,
  type: PropTypes.oneOf(['accent', 'base']).isRequired,
  children: PropTypes.node,
  className: spacingClassNamePropType,
  qaId: PropTypes.string,
};

Level.defaultProps = {
  level: '0',
  type: 'base',
  className: '',
};

export default Level;



// WEBPACK FOOTER //
// ./src/theme/level/index.jsx